<template>
	<div class="messages">
		<div v-for="message in messages"
			:key="message.id"
			v-bind:class="['message', { sent: message.sent || message.status === 'sent' }]">
			<div class="line">
				<i v-if="message.sent || message.status === 'sent'" class="el-icon-success"></i>
				<i v-if="message.status === 'unverified'" class="el-icon-warning"></i>
			</div>
			<div class="scheduled">
				<span class="date">{{ formatDate(message.time) }}</span>
				<span class="time">{{ formatTime(message.time) }}</span>
			</div>
			<div v-if="Array.isArray(message.confirmation)" class="confirmation">
				<!-- <el-tooltip
					v-for="confirm in message.confirmation"
					effect="light"
					:content="displayConfirmation(confirm, message)"
					placement="bottom-start">
					<i v-bind:class="[
						iconConfirmation(confirm),
						{
							success: confirm.status === 'sent',
							error: confirm.status === 'error'
						}
					]"></i>
			    </el-tooltip> -->
				<i v-for="(confirm, i) in message.confirmation"
					v-if="confirm != null"
					:key="confirm.channel + i"
					v-bind:class="[
						iconConfirmation(confirm),
						{
							success: confirm.status === 'sent',
							error: confirm.status === 'error'
						}
					]"></i>
			</div>
			<h3>{{ message.title }}</h3>
			<small></small>
			<p>{{ message.text }}</p>

			<p v-bind:class="['ref', message.ref_type]" v-if="message.ref_type">
				<i class="el-icon-link"></i>
				{{ getContentKey(message.ref_type, message.ref_id, 'title') }}
				<span>
					{{ message.ref_type }}
				</span>
			</p>
		</div>
	</div>
</template>

<script>
import ScheduledMessages from '../mixin/messages'

const ICON = {
	email: 'el-icon-message',
	sms: 'el-icon-chat-dot-square',
	apn: 'el-icon-mobile-phone'
}
const TEXT = {
	email: 'Email sent',
	sms: 'SMS sent',
	apn: 'iOS push notification sent',
	fcm: 'Android push notification sent'
}

export default {
	name: 'schedule-message-timeline',
	mixins: [ ScheduledMessages ],

	methods: {
		displayConfirmation(confirm, message) {
			return TEXT[confirm.channel]
		},
		iconConfirmation(confirm) {
			return ICON[confirm.channel]
		}
	}
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
